import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { GameSessionService } from './game-session.service';
import { filter, take, switchMap, takeUntil, tap } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { AuthState } from '../../core/models/auth.model';
import * as GameSessionActions from '../../core/store/game-session/game-session.actions';
import { Router } from '@angular/router';
import { RedirectService } from '../../core/services/redirect.service';
import { isSupportedLanguage } from '../../core/services/translation.service';
import { localizedURL } from '../../core/helpers/navigation.helper';
import { StorageService } from '../../core/services/storage.service';

@Injectable({
  providedIn: 'root'
})
export class GameSessionCheckService {
  constructor(
    private store: Store<{ auth: AuthState, gameSession: any }>,
    private gameSessionService: GameSessionService,
    private router: Router,
    private redirectService: RedirectService,
    private storageService: StorageService
  ) { }

  checkSession(destroy$: Subject<void>, redirectToGamelist = false): Observable<any> {
    return this.store.select(state => state.auth.user).pipe(
      filter(user => !!user),
      take(1),
      switchMap(user => {

        return this.gameSessionService.getCurrentSession().pipe(
          takeUntil(destroy$),
          tap(session => {
            this.store.dispatch(GameSessionActions.setCurrentSession({ session }));
            const savedLang = this.storageService.getLanguage(true);
            const lang = savedLang && isSupportedLanguage(savedLang) ? savedLang : 'en';

            if (session && session.status !== 'completed') {
              // Only redirect if we're not already in a room route
              const currentUrl = this.router.url;
              const isInRoom = currentUrl.includes('/playarea/room/');

              if (!isInRoom) {
                const playareaUrl = localizedURL('/playarea/room', lang);
                this.router.navigate([playareaUrl, session.id])
                  .catch(error => console.error('Navigation error:', error));
              }
            } else if (redirectToGamelist && !this.redirectService.hasRedirectUrl()) {
              const playareaUrl = localizedURL('/playarea', lang);
              this.router.navigate([playareaUrl])
                .catch(error => console.error('Navigation error:', error));
            }
          })
        );
      })
    );
  }

}
